<template>
  <v-card class="mx-auto" height="255" width="160" :color="customColor('cardColor')" @click="$emit('click')">
    <v-row justify="center">
      <v-col cols="auto">
        <v-img class="mt-3" height="128" max-width="128" contain :src="data.icon"></v-img>
      </v-col>
    </v-row>
    <v-card-text class="px-2 py-2">
      <div class="subtitle-1 text-truncate" style="max-width: 140px" :style="customColor('titleColor')">{{ data.name }}</div>
      <div class="_caption text-truncate" style="max-width: 140px" :style="customColor('contentColor')">{{ data.publisherName }}</div>
      <v-row class="mt-1 px-3" justify="space-between">
        <v-rating
          :value="data.rating"
          :color="customColor('ratingColor')"
          :background-color="customColor('ratingColor')"
          dense
          half-increments
          readonly
          size="12"
        ></v-rating>
        <div v-if="!discount.exist" style="font-size: 12px" :style="customColor('priceColor')">NT${{ price(data.price) }}{{ unit(data.price) }}</div>
        <div v-else class="text-decoration-line-through" style="font-size: 12px" :style="customColor('priceColor')">
          NT${{ price(data.price) }}{{ unit(data.price) }}
        </div>
      </v-row>
      <v-row v-show="discount.exist" class="pb-2 px-3" justify="space-between">
        <div style="font-size: 12px" :style="customColor('discountColor')">{{ discountPeriod }}</div>
        <div style="font-size: 12px" :style="customColor('discountColor')">NT${{ price(discount.price) }}{{ unit(discount.price) }}</div>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Product from '../store/product';

export default {
  name: 'CardV',
  props: {
    data: { type: Object, required: true },
    styleInfo: {
      type: Object,
      default: () => ({
        cardColor: 'white',
        titleColor: '#737373',
        contentColor: '#737373',
        ratingColor: '#737373',
        priceColor: '#007EAE',
        discountColor: 'red',
      }),
    },
  },
  data: () => ({
    discount: {},
  }),
  computed: {
    discountPeriod() {
      return Product.discountPeriod();
    },
  },
  created() {
    this.discount = Product.discountProc(this.data.discountPeriod, this.data.discount);
  },
  methods: {
    customColor(type) {
      switch (type) {
        case 'cardColor':
        case 'ratingColor':
          return this.styleInfo[type];
        default:
          return `color: ${this.styleInfo[type]}`;
      }
    },
    price(price) {
      return Product.price(price);
    },
    unit(price) {
      return this.$t(Product.unit(price));
    },
  },
};
</script>
